import React from 'react';
import ReactDOM from 'react-dom';
import { addLocaleData } from '../lib/i18n';
import { ReCaptchaProvider } from '../components/ReCaptcha';
import WhatsAppRequestForm, { VIEW } from '../components/WhatsAppRequestForm';
import { loadTrackers } from '../lib/tracker';
import '../lib/external/scroll-button';
import '../lib/external/auto-messages';
import '../styles/external/whatsapp.less';

const initial_state = window.__initialState__ || {};
const locale_info = window.__i18n__ || {};
const lng = (initial_state.lng = window.__lng__ || 'en');
const country_code = (initial_state.country_code = window.__country_code__ || 'US');
loadTrackers();
addLocaleData(lng, locale_info).then(() => {
  ReactDOM.render(
    <ReCaptchaProvider>
      {ReactDOM.createPortal(
        <WhatsAppRequestForm view={VIEW.LANDING_SHORT} country_code={country_code} />,
        document.getElementById('whatsapp_phone_number_request'),
      )}
      {ReactDOM.createPortal(
        <WhatsAppRequestForm view={VIEW.LANDING_FULL} country_code={country_code} />,
        document.getElementById('whatsapp_full_request'),
      )}
    </ReCaptchaProvider>,
    document.getElementById('root'),
  );
});
